import React, { createContext, useContext, useState } from "react";

const OptionContext = createContext();

export const OptionProvider = ({ children }) => {
  const [selectedOptions, setSelectedOptions] = useState(Array(80).fill(null));

  const handleOptionSelect = (questionIndex, option) => {
    const newOptions = [...selectedOptions];
    newOptions[questionIndex] = option;
    setSelectedOptions(newOptions);
  };

  return (
    <OptionContext.Provider value={{ selectedOptions, handleOptionSelect }}>
      {children}
    </OptionContext.Provider>
  );
};

export const useOptions = () => {
  const context = useContext(OptionContext);
  if (context === undefined) {
    throw new Error("useOptions must be used within an OptionProvider");
  }
  return context;
};
